import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import * as action from '../../store/DevelopmentOrder.action';
import { fetchTrafficLights } from '../../Bom/store/BOMConfig.action';

const initialState = {
  pageLoader: false,
  moduleData: null,
  devId: '',
  libId: '',
  isSignatureModal: false,
  signatureIndex: null,
  signatureData: null,
  isImageModal: false,
  imageIndex: null,
  imageData: null,
  isSignForTable: false,
  isMarkAsComplete: false,
  commentToggle: false,
  isAPIRequest: false,
};

export const StateContext = createContext(null);

export default function CustomModuleProductStateProvider({ children }) {
  const reducer = useSelector((reducerstate) => reducerstate);
  const { Measuremets } = reducer;
  const { customModulePermission } = Measuremets;
  const { customLibId, devOrderId } = useParams();
  const dispatch = useDispatch();
  const [customModuleProductState, setCustomModuleProductState] = useState({ ...initialState });
  const { moduleData } = customModuleProductState;
  const { t } = useTranslation('common');
  const rowHeight = 1122.52 / 50; // A4 height divided by number of rows
  useEffect(() => {
    const fetchCustomLibrary = async () => {
      setCustomModuleProductState((prevState) => ({
        ...prevState,
        pageLoader: true,
        devId: devOrderId,
        libId: customLibId,
        moduleData: null,
      }));
      const permissionObj = {
        customLibId,
        devOrderId,
      };
      await dispatch(action.UNMOUNT_CUSTOM_LIBRARY());
      await dispatch(action.getModulePermission(permissionObj));
      await dispatch(fetchTrafficLights(devOrderId));
      setCustomModuleProductState((prevState) => ({
        ...prevState,
        pageLoader: false,
      }));
    };
    if (customLibId) {
      fetchCustomLibrary();
    }
  }, [customLibId, devOrderId, dispatch]);

  useEffect(() => {
    if (customModulePermission) {
      setCustomModuleProductState((previosState) => ({
        ...previosState,
        isMarkAsComplete: customModulePermission?.isComplete,
        commentToggle: customModulePermission?.isVisibleToSupplier?.comment,
      }));
    }
  }, [customModulePermission]);

  const handleCloseSignature = () => {
    setCustomModuleProductState((previosState) => ({
      ...previosState,
      isSignatureModal: false,
      isSignForTable: false,
    }));
  };
  const handleCloseImageModal = () => {
    setCustomModuleProductState((previosState) => ({
      ...previosState,
      isImageModal: false,
    }));
  };

  const handleCompleteChackBox = async (e) => {
    setCustomModuleProductState((previosState) => ({
      ...previosState,
      isMarkAsComplete: e.target.checked,
    }));
    const parmas = {
      id: devOrderId,
      module: 'additionalInfo',
      data: {
        isComplete: e.target.checked,
        customLibId,
      },
    };
    await dispatch(action.markAsCompleteProducts(parmas, t));
  };

  const memoizedContextValue = useMemo(() => {
    return {
      initialState,
      customModuleProductState,
      setCustomModuleProductState,
      handleCloseSignature,
      handleCompleteChackBox,
      handleCloseImageModal,
      moduleData,
      rowHeight,
    };
  }, [customModuleProductState, initialState]);

  return <StateContext.Provider value={memoizedContextValue}>{children}</StateContext.Provider>;
}

export function useCustomModuleProductState() {
  const { t } = useTranslation('common');
  const context = useContext(StateContext);
  if (!context) {
    throw new Error(t('TAKING_DATES.CUSTOM_MODULE_PRODUCT_MESSAGE'));
  }
  return context;
}
